export default __webpack_public_path__ + "static/media/FORMULARIO-ADHERENCIA-Liraglutida-(SAXENDA).334fd6fd.pdf";